import { Center, HStack } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken, primitive, spacing } from 'styles/constants';

export const Container = HStack.withConfig({
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginTop: spacing.$0_5,
  space: '$5',
});

export const BadgeWrapper = Center.withConfig<{ $orange: boolean }>(p => ({
  backgroundColor: p.$orange
    ? getDesignToken('alert-info-background')
    : getDesignToken('alert-success-background'),
  minWidth: '$20',
  height: '$5',
  borderRadius: '5px',
}));

export const Badge = withTypography({
  fontSize: 'xs',
  textAlign: 'center',
  fontFamily: 'heading',
  color: primitive.$mayoEggWhite,
  lineHeight: 'xs',
});

export {
  incrementorButtonStyleProps as incrementorStyleProps,
  incrementorDisplayValueStyleProps as displayValueStyleProps,
} from 'pages/loyalty/loyalty-incentives-components/incentive-card/incrementor.styled';
